import { render, staticRenderFns } from "./ModalNoticeDanger.vue?vue&type=template&id=faf05fb0&"
import script from "./ModalNoticeDanger.vue?vue&type=script&lang=js&"
export * from "./ModalNoticeDanger.vue?vue&type=script&lang=js&"
import style0 from "./ModalNoticeDanger.vue?vue&type=style&index=0&id=faf05fb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports